// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"index_pageTitle_2qTpC","cardTitle":"index_cardTitle_7GKOx","filledBtn":"index_filledBtn_2KaYy","requiredMark":"index_requiredMark_13wip","stripe0":"index_stripe0_jbuN4","stripe1":"index_stripe1_hYvEH","stripe":"index_stripe_xa98e","vehiclesList":"index_vehiclesList_17QF1"};
    if(module.hot) {
      // 1788760852085
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":true});
      module.hot.dispose(cssReload);
      
    }
  